import { getNodeEnvironment, NodeEnvironment } from "./nodeEnvironment";
import { APPLICATION_URL, AwsAccountType, CTALocation, MarketingSource, NO_VALUE, YES_VALUE, GANDALF_LOGOUT_BETA_CLIENT_ID, GANDALF_LOGOUT_GAMMA_CLIENT_ID, GANDALF_LOGOUT_PROD_CLIENT_ID, COOKIE_EXPIRY_DATE, COOKIE_PATH, SubscriptionRequestType } from "./constants";
export const getApplicationURL = () => {
    const nodeEnvironment = getNodeEnvironment();
    switch (nodeEnvironment) {
        case NodeEnvironment.BETA: {
            return APPLICATION_URL.BETA;
        }
        case NodeEnvironment.GAMMA: {
            return APPLICATION_URL.GAMMA;
        }
        case NodeEnvironment.PROD: {
            return APPLICATION_URL.PROD;
        }
        default: {
            return APPLICATION_URL.DEVELOPMENT;
        }
    }
};
export const isPartnerAccount = (awsAccountType) => {
    return awsAccountType && awsAccountType === AwsAccountType.PARTNER;
};
//gets the partnerOriginatingOpportunity value for the finalizeTeamSubscription mutation call
export const mapPartnerOriginatedOpportunityValueToBoolean = (value) => {
    if (value === YES_VALUE) {
        return true;
    }
    else if (value === NO_VALUE) {
        return false;
    }
    return undefined;
};
export const getSubscriptionRequestsOrderTotal = (item) => {
    if (item.subscriptionRequestType == SubscriptionRequestType.MIDTERM) {
        // For mid-term add-ons, only calculate if we have an end date
        if (item.subscriptionEndDate) {
            return calculateMidtermPrice(item.subscriptionEndDate, item.pricePerSeat, item.numberOfSeats, item.discountPercentage, item.subscriptionStartDate);
        }
        else {
            return null;
        }
    }
    else {
        //discounts the total and rounds it to the nearest cent
        const nonDiscountedTotal = item.numberOfSeats * item.pricePerSeat;
        const discountedTotal = nonDiscountedTotal * (1 - (item.discountPercentage / 100));
        return (Math.round(discountedTotal * 100) / 100).toFixed(2);
    }
};
export const addCommaToPrice = (value) => {
    return new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(value);
};
export const matchRegex = (input, regex) => {
    if (input.match(regex) === null) {
        return false;
    }
    return true;
};
export const addYearToDate = (date, numOfYears) => {
    date.setFullYear(date.getFullYear() + numOfYears);
    return date;
};
export const addDayToDate = (date, numOfDays) => {
    date.setDate(date.getDate() + numOfDays);
    return date;
};
export const isRenewalUpdateWindowOpen = (date) => {
    // renewalWindowEndDate is 2 days before the subscription end date.
    const renewalWindowEndDate = addDayToDate(addYearToDate(date, 1), -2);
    return new Date() < renewalWindowEndDate;
};
export const getMarketingTrackingInfo = (search) => {
    const params = new URLSearchParams(search);
    // Digital Training page tracking
    if (params.get('dt') === 'sec') {
        if (params.get('sec') === 'ts') {
            return {
                source: MarketingSource.DIGITAL_TRAINING,
                location: CTALocation.BUILD_CLOUD_SKILLS
            };
        }
        if (params.get('sec') === 'gs') {
            return {
                source: MarketingSource.DIGITAL_TRAINING,
                location: CTALocation.GET_STARTED
            };
        }
    }
    // Team Subscription page tracking
    if (params.get('tmsb')) {
        if (params.get('cta') === 'header' && params.get('p') === '1') {
            return {
                source: MarketingSource.TEAM_SUBSCRIPTION,
                location: CTALocation.HEADER
            };
        }
        if (params.get('sec') === 'gs') {
            return {
                source: MarketingSource.TEAM_SUBSCRIPTION,
                location: CTALocation.GET_STARTED
            };
        }
    }
    // FAQ page tracking
    if (params.get('tfaq') === 'sec' && params.get('sec') === 'ts') {
        return {
            source: MarketingSource.FAQ,
            location: CTALocation.BUILD_CLOUD_SKILLS
        };
    }
    return null;
};
export const getUserPoolClientId = () => {
    const environment = getNodeEnvironment();
    switch (environment) {
        case NodeEnvironment.BETA:
            return GANDALF_LOGOUT_BETA_CLIENT_ID;
        case NodeEnvironment.GAMMA:
            return GANDALF_LOGOUT_GAMMA_CLIENT_ID;
        case NodeEnvironment.PROD:
            return GANDALF_LOGOUT_PROD_CLIENT_ID;
        default:
            return GANDALF_LOGOUT_BETA_CLIENT_ID;
    }
};
export const getGandalfLogoutURL = () => {
    const clientId = getUserPoolClientId();
    const domain = "login.us-east-1.auth.skillbuilder.aws";
    return `https://us-east-1.auth.skillbuilder.aws/logout?client_id=${clientId}&response_type=code&logout_uri=https://${domain}/logout?client_id=${clientId}`;
};
const clearCookie = (name) => {
    document.cookie = `${name}=;expires=${COOKIE_EXPIRY_DATE};path=${COOKIE_PATH}`;
};
export const clearAllCookies = () => {
    const cookies = document.cookie.split(";");
    cookies.forEach((cookie) => {
        const name = cookie.split("=")[0].trim();
        clearCookie(name);
    });
};
export const calculateMidtermPrice = (endDate, pricePerSeat, numberOfSeats, discountPercentage = 0, startDate) => {
    // Return null if any required parameter is missing
    if (!endDate || !pricePerSeat || !numberOfSeats) {
        return null;
    }
    // Ensure dates are Date objects
    const startDateObj = startDate ? new Date(startDate) : new Date();
    const endDateObj = new Date(endDate);
    // Calculate milliseconds between dates and convert to days
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const daysInSubscription = Math.round((endDateObj.getTime() - startDateObj.getTime()) / millisecondsPerDay) + 1;
    if (daysInSubscription > 0) {
        const percentOfYear = 1 - ((365 - daysInSubscription) / 365);
        const pricePerSeatforMidTerm = percentOfYear * pricePerSeat;
        const annualTotal = Number((numberOfSeats * pricePerSeatforMidTerm).toFixed(2));
        const discount = Number((annualTotal * (discountPercentage / 100)).toFixed(2));
        const orderTotal = annualTotal - discount;
        return orderTotal;
    }
    return null;
};
